/* global modForm modUtils */
/**
 * Unmark field as invalid
 * @param {Object} $field - element to unmark as invalid
 * @returns {Boolean} - false if no field provided
 */
const debounceA11yMutations = modUtils.debounce(function($field) {
	if ($field.getAttribute('type') === 'radio') {
		const firstRadio = $field.closest('fieldset').querySelector('input[type="radio"]:first-child');
		firstRadio.setAttribute('aria-invalid', 'false');
		firstRadio.removeAttribute('aria-describedby');
	} else {
		$field.setAttribute('aria-invalid', 'false');
		$field.removeAttribute('aria-describedby');
	}
}, 0);

export function unmarkFieldAsInvalid($field) {
	if (!$field) {
		return false;
	}
	const fieldParent = $field.parentElement.closest('.' + modForm.opts.errorParentCls);
	if (fieldParent) {
		fieldParent.classList.remove(modForm.opts.fieldErrorCls);
		const isActiveStepField = $field?.closest('.step')?.classList?.contains(modForm.opts.stepActiveCls);
		if (modForm.opts.addAccessibilityUpdates && isActiveStepField) {
			debounceA11yMutations($field);
		}
	} else {
		$field.parentElement.classList.remove(modForm.opts.fieldErrorCls);
	}
}
